import React from 'react';
import { useDispatch } from 'react-redux';
import Grid from '@mui/material/Grid';
import PartyAutocomplete from './partyautocomplete';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import PartyRelation from '../domain/partyrelation';
import IconButton from '@mui/material/IconButton';
import ConfirmationDialog from './confirmationdialog';
import PartyEditDialog from './partyeditdialog';
import { saveParty } from '../modules/partydata';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

export default function PartyView(props) {
    const parties = props.parties;
    const dispatch = useDispatch();
    const showControls = props.showControls;
    const [showAc, setShowAc] = React.useState(false);
    const [showRoleSelect, setShowRoleSelect] = React.useState(false);
    const [selectedParty, setSelectedParty] = React.useState(null);
    const [selectedPartyRole, setSelectedPartyRole] = React.useState(0);
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [partyToRemove, setPartyToRemove] = React.useState({});
    const [newPartyDialogOpen, setNewPartyDialogOpen] = React.useState(false);
    const { t } = useTranslation();

    const onDismiss = () => {
        setShowAc(false);
        setShowRoleSelect(false);
        setSelectedPartyRole(0);
        setSelectedParty(null);
    };

    const onSelect = (item) => {
        setSelectedParty(item);
        setShowAc(false);
        setShowRoleSelect(true);
    };

    const onSaveNewParty = () => {
        props.saveNewPartyRelation(selectedParty, selectedPartyRole);
        onDismiss();
    };

    const onRemoveParty = () => {
        props.removeParty(partyToRemove.id, partyToRemove.relation);
        setPartyToRemove({});
        setConfirmOpen(false);
    };

    const saveNewParty = async (party) => {
        const resp = await saveParty(party)(dispatch);
        if (resp) {
            setNewPartyDialogOpen(false);
        } else {
        }
    };
    const cancelNewParty = () => {
        setNewPartyDialogOpen(false);
    };

    return (
        <React.Fragment>
            {parties && parties.length > 0 && (
                <Paper sx={{ width: '100%', mb: '5px' }}>
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <Table sx={{ width: '100%' }} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('general.name')}</TableCell>
                                    <TableCell>{t('general.phone')}</TableCell>
                                    <TableCell>{t('general.email')}</TableCell>
                                    <TableCell>{t('general.role')}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {parties.map((party) => (
                                    <TableRow key={party.relatedParty.id}>
                                        <TableCell>{party.relatedParty.name}</TableCell>
                                        <TableCell>{party.relatedParty.phonenumber}</TableCell>
                                        <TableCell>{party.relatedParty.email}</TableCell>
                                        <TableCell>{PartyRelation.PartyRelationText(party.relation)}</TableCell>
                                        <TableCell>
                                            {showControls && (
                                                <IconButton
                                                    size="small"
                                                    name="party-remove"
                                                    onClick={() => {
                                                        setPartyToRemove({
                                                            id: party.relatedParty.id,
                                                            relation: party.relation,
                                                            name: party.relatedParty.name,
                                                        });
                                                        setConfirmOpen(true);
                                                    }}>
                                                    <i
                                                        className="fas fa-trash-alt fa-lg"
                                                        style={{ color: 'red' }}
                                                        title={t('buttons.remove')}
                                                    />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <Table sx={{ width: '100%' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('general.name')}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {parties.map((party) => (
                                    <TableRow key={party.relatedParty.id}>
                                        <TableCell>
                                            {party.relatedParty.name}
                                            <br />
                                            {party.relatedParty.phonenumber}
                                            <br />
                                            {party.relatedParty.email}
                                            <br />
                                            {PartyRelation.PartyRelationText(party.relation)}
                                        </TableCell>
                                        <TableCell>
                                            {showControls && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() =>
                                                        onRemoveParty(party.relatedParty.id, party.relation)
                                                    }>
                                                    <i
                                                        className="fas fa-trash-alt fa-lg"
                                                        style={{ color: 'red' }}
                                                        title={t('buttons.remove')}
                                                    />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </Paper>
            )}
            {!showAc && showControls && (
                <Grid item xs={12}>
                    <Button
                        name="add-new-relation"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setShowAc(true);
                        }}>
                        {t('buttons.add')}
                    </Button>
                </Grid>
            )}
            {(showAc || showRoleSelect) && showControls && (
                <Grid item container>
                    {showRoleSelect && (
                        <Grid item xs={8}>
                            <b>
                                <br />
                                {selectedParty.name}
                            </b>
                            <FormControl sx={{ mt: 2, mx: 1, width: '95%' }}>
                                <InputLabel id="role-selector">{t('general.role')}</InputLabel>
                                <Select
                                    labelId="role-selector"
                                    id="role-selector"
                                    name="role-selector"
                                    value={selectedPartyRole}
                                    onChange={(evt) => {
                                        setSelectedPartyRole(evt.target.value);
                                    }}>
                                    <MenuItem key={0} value={0}>
                                        {t('general.optionNotSelected')}
                                    </MenuItem>
                                    {PartyRelation.AllRelations().map((relation) => (
                                        <MenuItem key={relation.value} value={relation.value}>
                                            {relation.text}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    {showAc && (
                        <Grid item xs={8}>
                            <PartyAutocomplete
                                selected={onSelect}
                                dismiss={onDismiss}
                                newParty={() => setNewPartyDialogOpen(true)}
                            />
                            <Tooltip title={t('general.addContactPersonHint')}>
                                <IconButton>
                                    <HelpIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    )}
                    <Grid item xs={4}>
                        {showRoleSelect && (
                            <Button
                                sx={{ mt: '15px', ml: '5px' }}
                                variant="contained"
                                color="primary"
                                disabled={!selectedParty || selectedPartyRole === 0}
                                onClick={onSaveNewParty}>
                                {t('buttons.save')}
                            </Button>
                        )}
                        <Button
                            sx={{ mt: '15px', ml: '5px' }}
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                setShowAc(false);
                                setShowRoleSelect(false);
                            }}>
                            {t('buttons.cancel')}
                        </Button>
                    </Grid>
                </Grid>
            )}
            <ConfirmationDialog
                open={confirmOpen}
                confirm={() => onRemoveParty()}
                cancel={() => setConfirmOpen(false)}
                confirmText={t('buttons.remove')}>
                {t('general.confirmRemoveContactPerson', { contactName: partyToRemove.name })}
            </ConfirmationDialog>
            <PartyEditDialog open={newPartyDialogOpen} cancel={cancelNewParty} save={saveNewParty} />
        </React.Fragment>
    );
}
